/**
 * Google Analytics 4 — audience du site.
 *
 * Même règle que le pixel Meta : RIEN ne se charge tant que le visiteur n'a pas
 * dit oui (voir lib/consentement.js). On ne charge pas le script en « mode
 * consentement » de Google avec les mesures bridées : tant qu'il n'y a pas de
 * oui, on ne contacte pas Google du tout. C'est plus simple à expliquer dans la
 * politique, et plus facile à vérifier — il suffit de regarder s'il y a une
 * requête vers googletagmanager.
 *
 * Comme pixel.js, ce fichier ne vit que sur roofborder.com. Le widget servi aux
 * couvreurs (backend WIDGET_JS) ne le charge JAMAIS : mesurer l'audience de
 * LEURS sites pour notre compte serait fautif.
 *
 * GA4 n'enregistre pas les adresses IP (contrairement à l'ancien Universal
 * Analytics, il n'y a donc PAS de paramètre « anonymize_ip » à activer ici :
 * il n'existe plus et le passer ne ferait rien).
 */

import { pistageAutorise } from "@/lib/consentement";

// Identifiant de mesure GA4 (Administration → Flux de données → Web).
// Vide = aucun script chargé, aucun cookie posé.
export const GA_ID = "G-XF23Y8HC3K";

let charge = false;

/** Charge gtag.js. Idempotent, sans effet sans identifiant ou sans consentement. */
export function initAnalytics() {
  if (charge || !GA_ID || !pistageAutorise()) return;
  charge = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  gtag("js", new Date());
  // `send_page_view: false` est ESSENTIEL ici : la vue automatique de GA4 ne se
  // déclenche qu'au premier chargement. Dans une application à page unique, tout
  // le reste de la visite passerait inaperçu — on les envoie donc à la main à
  // chaque changement de route (voir vuePage).
  gtag("config", GA_ID, { send_page_view: false });
}

/** Vue de page. À rappeler à chaque changement de route. */
export function vuePage() {
  if (!window.gtag || !charge) return;
  window.gtag("event", "page_view", {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
}

/**
 * Évènement GA4 (sign_up, begin_checkout, generate_lead…).
 * Volontairement mince : aucune donnée personnelle ne part d'ici — ni courriel,
 * ni adresse de propriété, ni montant de soumission nominatif.
 */
export function evenementGA(nom, params) {
  if (!window.gtag || !charge) return;
  window.gtag("event", nom, params || {});
}
